// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class ConditionByLevelWithNotesDetails {
  levelID: string;
  levelDescription: string;
  conditionID: string;
  conditionDescription: string;
  pmHours: number;
  engHours: number;
  grapHours: number;
  progHours: number;
  specHours: number;
  ddsHours: number;
  mechHours: number;
  elecHours: number;
  servicingOffice: string;
  notes: string;
  typicalOfCount: string;
}
